// D16-v2 — welcome-страница для OWNER, который принимает invite. Публичный
// route (без RequireAuth — у OWNER ещё нет аккаунта, на котором можно
// аутентифицироваться). Token в URL — single-use UUID из platform.invitation,
// валидируется backend'ом на каждый запрос (GET → preview, POST → consume).
import { createFileRoute } from '@tanstack/react-router'
import { OwnerOnboardingScreen } from '../features/owner-onboarding/OwnerOnboardingScreen'

export const Route = createFileRoute('/welcome/$token')({
  component: OwnerOnboardingScreen,
})
